export default "__VITE_ASSET__Cce2GsE3__"